import { baseClientHttp, clientTranscript } from "../config/axios";
import { bufferToFile as _bufferToFile } from "../utils/Utils";

export const getSignedUrl = async (data) => {
    const response = await clientTranscript.post(`/signed-url`, data);
    return response.data;
}

export const getObjectBykey = async (key,{responseType="arraybuffer",bufferToFile = _bufferToFile} = {}) => {
    const params = {
        Key: key,
    };
    const uri = await getSignedUrl({ clientMethod: "get_object", params });
    const data = await baseClientHttp.get(uri?.url,{responseType});
    return { ...(uri?.params??{}), file: bufferToFile(data.data, key?.split("/")?.reverse()[0]) };
};

export const getMetaData = async (key) => {
    const metadata = await clientTranscript.post(`/metadata-file`, { params: { Key: key } });
    return metadata.data;
}

export const uploadFile = async (
    params,
    file,
    { dispatch = () => { } } = {}
) => {
    let uri = await getSignedUrl({ clientMethod: "put_object", params });
    uri = uri?.url;
    try {
        const response = await baseClientHttp.put(uri, file, {
            headers: {
                'Content-Type': params.ContentType,
            },
            onUploadProgress: (progressEvent) => {
                const progress = Math.round((progressEvent.loaded * 100) / progressEvent.total);
                dispatch({ type: "UPDATE_PROGRESS", payload: progress });
            }
        });
        dispatch({ type: "UPLOAD_SUCCESS", payload: params.Key });
        return response.data;
    } catch (error) {
        dispatch({
            type: "UPLOAD_FAILURE",
            payload: "Error al subir el archivo.",
        });
    }
    return null;
};

//data = {OldKey, NewKey}
export const renameS3Object = async (data) => {
    const response = await clientTranscript.post(`/rename-file`, data);
    return response.data;
}

export const deleteS3Object = async (data) => {
    const response = await clientTranscript.post(`/delete-file`, data);
    return response.data;
}